// ABOUTME: Provides one shared product-search engine and dropdown for the collection and header.
// ABOUTME: Fully replaces Shopify predictive results so both search bars behave identically.
// DATA FLOW: Either search input -> shared catalog and suggestion lookup -> identical result rows.
// DEPENDENCIES: Shopify /products.json, /search/suggest.json, and collection search CSS classes.
(function () {
  if (window.__peptikFuzzyHeaderBound) return;
  window.__peptikFuzzyHeaderBound = true;

  // Search is deliberately OUTSIDE the desktop gate (Big Cheese 2026-08-05). The gate keeps
  // `mobile-only` products out of the browsable grid, where a competitor scrapes the
  // catalogue; someone who types the name already knows it exists, so hiding it there only
  // costs a sale. The collection-page search bar never filtered either, so both bars behave
  // the same.

  // ----- Sold-out styling for header search hits -----
  // The hit displays a product's pen/vial namesake variant; when THAT variant
  // is out of stock the hit is crossed out (both our fuzzy hits and Shopify's
  // native predictive product cards).
  (function injectStyle() {
    if (document.getElementById('peptik-fuzzy-soldout-style')) return;
    var s = document.createElement('style');
    s.id = 'peptik-fuzzy-soldout-style';
    s.textContent =
      '.peptik-fuzzy__hit--soldout,.predictive-search-results__card--soldout{opacity:.6;}' +
      '.peptik-fuzzy__hit--soldout .peptik-fuzzy__title,' +
      '.predictive-search-results__card--soldout .predictive-search-results__card-title,' +
      '.predictive-search-results__card--soldout .resource-card__title,' +
      '.predictive-search-results__card--soldout .resource-card__title-link{text-decoration:line-through;text-decoration-thickness:1.5px;}' +
      '.peptik-fuzzy__soldout,.predictive-search-results__card--soldout .peptik-native-soldout{display:inline-block;margin-top:2px;font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#b42318;}';
    (document.head || document.documentElement).appendChild(s);
  })();

  // ----- Catalog (cached for the session) -----
  var catalogPromise = null;
  var catalogByHandle = Object.create(null);
  // Priorite marchande commune aux trois tris de ce module et a la barre du catalogue
  // (sections/main-collection.liquid) : best-seller + stylo, puis best-seller, puis le reste.
  // Pilotee par les tags produit depuis l'admin — jamais par une liste de handles en dur.
  // Big Cheese 2026-08-11 : "reta pen is the best seller", il doit sortir en premier.
  // Format vendu par une fiche, d'apres son titre — meme regle que la carte de collection
  // (snippets/product-card.liquid) : "une fiche intitulee ...Pen doit cibler sa variante Pen".
  function peptikFormat(entry) {
    var t = ((entry && entry.title) || '').toLowerCase();
    if (t.indexOf('spray') !== -1 || t.indexOf('nasal') !== -1) return 'spray';
    if (t.indexOf('pen') !== -1) return 'pen';
    if (t.indexOf('vial') !== -1) return 'vial';
    return '';
  }

  // Variante a ouvrir depuis un resultat de recherche. Sans elle, le lien porte la seule
  // reference produit et la fiche retombe sur selected_or_first_available_variant : sur le
  // stylo RETA, dont le 10mg est epuise, c'etait le FLACON qui s'ouvrait — un client qui
  // clique "Pen" atterrissait sur un vial (2026-08-11).
  function peptikVariantMatchesFormat(variant, fmt) {
    var title = ((variant && variant.title) || '').toLowerCase();
    if (fmt === 'pen') return title.indexOf('pen') !== -1 || title.indexOf('ready-to-use') !== -1 || title.indexOf('ready to use') !== -1;
    if (fmt === 'vial') return title.indexOf('vial') !== -1;
    if (fmt === 'spray') return title.indexOf('spray') !== -1 || title.indexOf('nasal') !== -1;
    return false;
  }

  function peptikVariantOfFormat(entry, fmt) {
    var vs = (entry && entry.variants) || [];
    if (!fmt || !vs.length) return null;
    var duFormat = vs.filter(function (v) { return peptikVariantMatchesFormat(v, fmt); });
    if (!duFormat.length) return null;
    var dispo = duFormat.filter(function (v) { return v.available; })[0];
    return dispo || duFormat[0];
  }

  function peptikVarianteCibleComplete(entry) {
    return peptikVariantOfFormat(entry, peptikFormat(entry));
  }

  function peptikVarianteCible(entry) {
    var variant = peptikVarianteCibleComplete(entry);
    return (variant && variant.id) || null;
  }

  function peptikUrlVariante(url, id) {
    if (!id || !url) return url;
    if (url.indexOf('variant=') !== -1) return url;
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + id;
  }

  function peptikPrio(tags) {
    var t = tags || '';
    if (t.indexOf('best seller') === -1) return 2;
    return /(^|\s)pen(\s|$)/.test(t) ? 0 : 1;
  }

  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        return ((d && d.products) || []).map(function (p) {
          // The hit DISPLAYS the product's hero image (images[0]). Sold-out
          // cross-out must read from the variant whose image that is — NOT
          // variants[0]. For bundles variants[0] is often the Vial while the
          // displayed hero (and the card) is the Pen, so matching by image is
          // what keeps search, card and PDP consistent.
          // Match on the image FILENAME (basename) so URL-prefix differences
          // between product image and variant image don't break the match.
          var displayImg = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src.split('?')[0].split('/').pop() : '';
          var dv = null;
          if (displayImg && Array.isArray(p.variants)) {
            for (var vi = 0; vi < p.variants.length; vi++) {
              var fimg = p.variants[vi].featured_image;
              if (fimg && fimg.src && fimg.src.split('?')[0].split('/').pop() === displayImg) { dv = p.variants[vi]; break; }
            }
          }
          if (!dv) dv = p.variants && p.variants[0];
          var rawTags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
          var bundleProduct = String(p.product_type || '').toLowerCase() === 'bundle'
            || rawTags.some(function (tag) { return /^bundles?$/i.test(String(tag || '').trim()); });
          // If the hero belongs to an unavailable dosage, promote the first available
          // variant of the product's own format. This keeps every early render coherent,
          // before query-specific formatting is applied.
          var productFormat = peptikFormat(p);
          if (dv && !dv.available && productFormat && Array.isArray(p.variants)) {
            for (var pi = 0; pi < p.variants.length; pi++) {
              if (p.variants[pi].available && peptikVariantMatchesFormat(p.variants[pi], productFormat)) {
                dv = p.variants[pi];
                break;
              }
            }
          }
          // Sold-out must judge the FORMAT, not the single matched variant. Since dosage became
          // a second option, a pen product carries Pen/10mg AND Pen/40mg: with 10mg out of stock
          // the hit was crossed out even though the 40mg pen is on the shelf and buyable. Look
          // for any variant of the same format that is available.
          var dvFormat = '';
          if (dv && dv.title) {
            var dvt = dv.title.toLowerCase();
            if (dvt.indexOf('pen') !== -1) dvFormat = 'pen';
            else if (dvt.indexOf('vial') !== -1) dvFormat = 'vial';
            else if (dvt.indexOf('spray') !== -1) dvFormat = 'spray';
          }
          var formatAvailable = dv ? !!dv.available : true;
          if (bundleProduct && Array.isArray(p.variants)) {
            formatAvailable = p.variants.some(function (variant) { return !!variant.available; });
          } else if (!formatAvailable && Array.isArray(p.variants)) {
            for (var ai = 0; ai < p.variants.length; ai++) {
              var av = p.variants[ai];
              if (!av || !av.available) continue;
              // No format word on the displayed variant (single-variant products): any
              // available variant means the product is buyable.
              if (!dvFormat || (av.title || '').toLowerCase().indexOf(dvFormat) !== -1) { formatAvailable = true; break; }
            }
          }
          var searchAliases = rawTags
            .map(function (tag) { return String(tag || '').trim().toLowerCase(); })
            .filter(function (tag) { return tag.indexOf('search alias ') === 0; })
            .map(function (tag) { return tag.slice('search alias '.length); })
            .join(' ');
          var entry = {
            id: p.id,
            title: p.title || '',
            handle: p.handle || '',
            body: (p.body_html || '').replace(/<[^>]*>/g, ' ').slice(0, 800),
            vendor: p.vendor || '',
            product_type: (p.product_type || '').toLowerCase(),
            tags: Array.isArray(p.tags) ? p.tags.join(' ').toLowerCase() : (p.tags || '').toLowerCase(),
            search_aliases: searchAliases,
            image: (dv && dv.featured_image && dv.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '',
            price: dv ? dv.price : '',
            available: formatAvailable,
            // Pen + Vial variants, so a matched bundle can be split into two
            // hits (a bundle is one product carrying both formats).
            variants: (Array.isArray(p.variants) ? p.variants : []).map(function (v) {
              return {
                id: v.id,
                title: v.title || '',
                price: v.price,
                available: !!v.available,
                image: (v.featured_image && v.featured_image.src) || '',
              };
            }),
            url: '/products/' + p.handle,
          };
          catalogByHandle[entry.handle] = entry;
          return entry;
        });
      })
      .catch(function () { return []; });
    return catalogPromise;
  }

  function normalize(s) { return (s || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var prev = new Array(b.length + 1);
    var curr = new Array(b.length + 1);
    for (var j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      curr[0] = i;
      for (var k = 1; k <= b.length; k++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(k - 1) ? 0 : 1;
        curr[k] = Math.min(prev[k] + 1, curr[k - 1] + 1, prev[k - 1] + cost);
      }
      var tmp = prev; prev = curr; curr = tmp;
    }
    return prev[b.length];
  }
  // Min edits to match q as a fuzzy SUBSTRING of t — the match may start and end
  // anywhere in t for free, so a short typo'd prefix like "tizepa" aligns to
  // "tirzepa" inside "tirzepatidenextgenpen" at distance 1 (not the huge
  // full-string distance that the old token Levenshtein produced).
  function fuzzyContains(q, t) {
    var m = q.length, n = t.length;
    if (m === 0) return 0;
    if (n === 0) return m;
    var prev = new Array(n + 1);
    for (var j = 0; j <= n; j++) prev[j] = 0; // start anywhere in t is free
    for (var i = 1; i <= m; i++) {
      var curr = new Array(n + 1);
      curr[0] = i;
      for (var k = 1; k <= n; k++) {
        var cost = q.charCodeAt(i - 1) === t.charCodeAt(k - 1) ? 0 : 1;
        curr[k] = Math.min(prev[k] + 1, curr[k - 1] + 1, prev[k - 1] + cost);
      }
      prev = curr;
    }
    var min = Infinity;
    for (var z = 0; z <= n; z++) if (prev[z] < min) min = prev[z];
    return min;
  }
  // Jaro-Winkler similarity (0..1) — robust to transpositions and garbled
  // typos that defeat plain edit distance, e.g. "tizapeti" vs "tirzepatide".
  function jaro(s1, s2) {
    if (s1 === s2) return 1;
    var l1 = s1.length, l2 = s2.length;
    if (!l1 || !l2) return 0;
    var md = Math.max(0, Math.floor(Math.max(l1, l2) / 2) - 1);
    var m1 = new Array(l1).fill(false), m2 = new Array(l2).fill(false), m = 0;
    for (var i = 0; i < l1; i++) {
      var lo = Math.max(0, i - md), hi = Math.min(i + md + 1, l2);
      for (var j = lo; j < hi; j++) { if (m2[j] || s1[i] !== s2[j]) continue; m1[i] = m2[j] = true; m++; break; }
    }
    if (!m) return 0;
    var t = 0, k = 0;
    for (var i2 = 0; i2 < l1; i2++) { if (!m1[i2]) continue; while (!m2[k]) k++; if (s1[i2] !== s2[k]) t++; k++; }
    t /= 2;
    return (m / l1 + m / l2 + (m - t) / m) / 3;
  }
  function jw(s1, s2) {
    var j = jaro(s1, s2), p = 0, max = Math.min(4, Math.min(s1.length, s2.length));
    for (var i = 0; i < max; i++) { if (s1[i] === s2[i]) p++; else break; }
    return j + p * 0.1 * (1 - j);
  }
  // Returns a small distance-like score for a match, Infinity otherwise.
  // Two ways to match: (a) a fuzzy SUBSTRING within 30% of the query length
  // (good for partials like "ghk", "bpc157"); (b) a token whose Jaro-Winkler
  // similarity to the query is >= 0.82 (good for garbled typos).
  function score(query, p) {
    var q = normalize(query);
    if (q.length < 2) return Infinity;
    // A product-name prefix is more relevant than the same letters inside a
    // vendor name (for example, "pt" occurs in "Peptik" on every product).
    // Keep availability ordering in fuzzyFind unchanged.
    if (normalize(p.title).indexOf(q) === 0 || normalize(p.handle).indexOf(q) === 0) return -1;
    var fields = [p.title, p.handle, p.vendor, p.search_aliases];
    var bestFc = Infinity, bestJwDist = Infinity, exact = false;
    for (var i = 0; i < fields.length; i++) {
      var fNorm = normalize(fields[i]);
      if (!fNorm) continue;
      if (fNorm.indexOf(q) !== -1) { exact = true; }
      var fc = fuzzyContains(q, fNorm) / q.length;
      if (fc < bestFc) bestFc = fc;
      var tokens = fields[i].toLowerCase().split(/[^a-z0-9]+/);
      for (var j = 0; j < tokens.length; j++) {
        if (tokens[j].length < 3) continue;
        var d = 1 - jw(q, tokens[j]);
        if (d < bestJwDist) bestJwDist = d;
      }
    }
    if (exact) return 0;
    if (bestFc <= 0.30 || bestJwDist <= 0.18) return Math.min(bestFc, bestJwDist);
    return Infinity;
  }
  function mounjaroSynonym(query){
    var qn = (query || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, '');
    // "Mounjaro" is the brand name for Tirzepatide — surface Tirzepatide for it.
    if (qn && (('mounjaro'.indexOf(qn) === 0 && qn.length >= 4) || qn.indexOf('mounjaro') !== -1)) return 'tirzepatide';
    return query;
  }
  function fuzzyFind(query, limit) {
    query = mounjaroSynonym(query);
    return loadCatalog().then(function (catalog) {
      var q = normalize(query);
      if (q.length < 2) return [];
      // score() already applies the 30% substring / 0.82 Jaro-Winkler match
      // thresholds and returns Infinity for non-matches.
      var scored = catalog.map(function (p) { return { p: p, s: score(query, p) }; });
      return scored
        .filter(function (x) { return isFinite(x.s); })
        .sort(function (a, b) {
        var aA = a.p.available !== false, bA = b.p.available !== false;
        if (aA !== bA) return aA ? -1 : 1;                 // in-stock first
        if (a.s !== b.s) return a.s - b.s;                 // exact/relevant matches first
        var aR = peptikPrio(a.p.tags), bR = peptikPrio(b.p.tags);
        if (aR !== bR) return aR - bR;                     // best-seller / pen first
        var aP = parseFloat(a.p.price); if (!isFinite(aP)) aP = Infinity;
        var bP = parseFloat(b.p.price); if (!isFinite(bP)) bP = Infinity;
        if (aP !== bP) return aP - bP;                     // lowest price first
        return 0;
      })
        .slice(0, limit || 6)
        .map(function (x) { return x.p; });
    });
  }

  // ----- Bundle format splitting -----
  function isBundle(entry) {
    if (!entry) return false;
    if (entry.product_type === 'bundle') return true;
    return /(^|\s)bundles?(\s|$)/.test(entry.tags || '');
  }
  // Each matched multi-format bundle becomes one hit per format, deep-linked
  // to its exact variant. The limit is applied to whole products so the final
  // result slot can never keep Vial while silently cutting Pen or Spray.
  function expandBundles(list, limit) {
    var out = [];
    list.forEach(function (p) {
      if (limit && out.length >= limit) return;
      var group = [];
      if (isBundle(p) && p.variants && p.variants.length >= 2) {
        [{ format: 'pen', label: 'Pen' }, { format: 'spray', label: 'Spray' }, { format: 'vial', label: 'Vial' }]
          .forEach(function (choice) {
            var variant = peptikVariantOfFormat(p, choice.format);
            if (!variant) return;
            group.push({
              id: String(p.id) + ':' + variant.id,
              title: p.title + ' (' + choice.label + ')',
              handle: p.handle,
              image: variant.image || p.image,
              price: variant.price,
              available: variant.available,
              tags: p.tags,
              url: '/products/' + p.handle + '?variant=' + variant.id,
              _split: true,
            });
          });
        if (group.length >= 2) {
          group = group.filter(function (entry) { return entry.available; })
            .concat(group.filter(function (entry) { return !entry.available; }));
          if (!limit || out.length + group.length <= limit || out.length === 0) {
            Array.prototype.push.apply(out, group);
          }
          return;
        }
      }
      out.push(p);
    });
    return out;
  }

  // ----- Shared collection and header search -----
  // Both surfaces call this exact function. Shopify predictive search remains only as the
  // header dialog shell; its own requests, cards, recent products and messages are removed.
  function expandQuery(raw) {
    var q = (raw || '').trim();
    if (!q) return [];
    var variants = new Set([q]);
    variants.add(q.replace(/([a-zA-Z])(\d)/g, '$1-$2').replace(/(\d)([a-zA-Z])/g, '$1-$2'));
    variants.add(q.replace(/([a-zA-Z])(\d)/g, '$1 $2').replace(/(\d)([a-zA-Z])/g, '$1 $2'));
    if (q.indexOf('-') !== -1) variants.add(q.replace(/-/g, ''));
    if (q.indexOf(' ') !== -1) variants.add(q.replace(/\s+/g, ''));
    return Array.from(variants).filter(function (value) { return value.length >= 2; });
  }

  function suggestionUrl(query) {
    return '/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product&resources[limit]=8'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,vendor,tag,body';
  }

  function requestedFormat(query) {
    var words = ' ' + String(query || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ') + ' ';
    if (/\spens?\s/.test(words)) return 'pen';
    if (/\svials?\s/.test(words)) return 'vial';
    if (/\ssprays?\s/.test(words) || /\snasal\s/.test(words)) return 'spray';
    return '';
  }

  function queryWithoutRequestedFormat(query, format) {
    if (!format) return query;
    var reduced = String(query || '').replace(/\b(pens?|vials?|sprays?|nasal)\b/gi, ' ').replace(/\s+/g, ' ').trim();
    return reduced || query;
  }

  function entryForRequestedFormat(entry, format) {
    if (!entry || !format || !Array.isArray(entry.variants)) return entry;
    var variant = peptikVariantOfFormat(entry, format);
    if (!variant) return entry;
    var formatted = Object.assign({}, entry, {
      image: variant.image || entry.image,
      price: variant.price,
      available: variant.available,
      url: '/products/' + entry.handle + '?variant=' + variant.id,
    });
    if (format === 'pen') {
      formatted.title = formatted.title.replace('Lyophilized Vial + Sterile Water', 'Next-Gen Dual-Chamber Pen');
    } else if (format === 'vial') {
      formatted.title = formatted.title
        .replace('Next-Gen Dual-Chamber Pen', 'Lyophilized Vial + Sterile Water')
        .replace(' Pen Dual-Chamber', '');
    }
    return formatted;
  }

  function unifiedFind(query, signal) {
    // The catalog is the deterministic source of truth. Normalization already removes spaces
    // and punctuation, so `tb500`, `TB-500` and `tb 500` are the same query without relying on
    // Shopify's inconsistent predictive endpoint.
    var format = requestedFormat(query);
    var catalogQuery = queryWithoutRequestedFormat(query, format);
    return fuzzyFind(catalogQuery, 20).then(function (merged) {
      merged = merged.map(function (entry, index) { return { entry: entry, index: index }; })
        .sort(function (a, b) {
          if (a.entry.available !== b.entry.available) return a.entry.available ? -1 : 1;
          return a.index - b.index;
        })
        .map(function (item) { return item.entry; });
      var formatted = format
        ? merged.slice(0, 8).map(function (entry) { return entryForRequestedFormat(entry, format); })
        : merged;
      var products = format ? formatted.slice(0, 8) : expandBundles(formatted, 8);
      products = products.map(function (entry) {
        if (entry._split) return entry;
        var variant = peptikVarianteCibleComplete(entry);
        if (!variant) return entry;
        return Object.assign({}, entry, {
          image: variant.image || entry.image,
          price: variant.price,
          available: variant.available,
          url: peptikUrlVariante(entry.url, variant.id),
        });
      });
      return products;
    });

    var suggestionRequests = expandQuery(query).map(function (variant) {
      return fetch(suggestionUrl(variant), { signal: signal, headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          return (data && data.resources && data.resources.results && data.resources.results.products) || [];
        })
        .catch(function (error) {
          if (error.name === 'AbortError') throw error;
          return [];
        });
    });

    return Promise.all([loadCatalog(), Promise.all(suggestionRequests), fuzzyFind(query, 20)])
      .then(function (parts) {
        var seen = new Set();
        var merged = [];
        parts[1].forEach(function (group) {
          group.forEach(function (suggestion) {
            var handle = suggestion && suggestion.handle;
            if (!handle || seen.has(handle)) return;
            var catalogEntry = catalogByHandle[handle];
            if (!catalogEntry) return;
            var entry = Object.assign({}, catalogEntry);
            entry.url = suggestion.url || entry.url;
            seen.add(handle);
            merged.push(entry);
          });
        });
        parts[2].forEach(function (entry) {
          if (!entry || !entry.handle || seen.has(entry.handle)) return;
          seen.add(entry.handle);
          merged.push(entry);
        });

        merged = merged.map(function (entry, index) { return { entry: entry, index: index }; })
          .sort(function (a, b) {
            if (a.entry.available !== b.entry.available) return a.entry.available ? -1 : 1;
            var priority = peptikPrio(a.entry.tags) - peptikPrio(b.entry.tags);
            if (priority !== 0) return priority;
            var aPrice = parseFloat(a.entry.price); if (!isFinite(aPrice)) aPrice = Infinity;
            var bPrice = parseFloat(b.entry.price); if (!isFinite(bPrice)) bPrice = Infinity;
            if (aPrice !== bPrice) return aPrice - bPrice;
            return a.index - b.index;
          })
          .map(function (item) { return item.entry; });

        var products = expandBundles(merged.slice(0, 8)).slice(0, 8);
        products.forEach(function (entry) {
          if (entry._split) return;
          var variantId = peptikVarianteCible(entry);
          if (variantId) entry.url = peptikUrlVariante(entry.url, variantId);
        });
        return products;
      });
  }

  function formatPrice(raw) {
    var aed = parseFloat(raw);
    if (!isFinite(aed)) return '';
    var rounded = Math.round(aed);
    return (Math.abs(aed - rounded) < 0.005 ? rounded : aed.toFixed(2)) + ' AED';
  }

  function priceCents(raw) {
    var aed = parseFloat(raw);
    return isFinite(aed) ? String(Math.round(aed * 100)) : '';
  }

  function renderUnifiedResults(results, products) {
    if (!products.length) {
      results.innerHTML = '<div class="peptik-cat-search__empty">No matches. Press Enter to see all results.</div>';
      results.hidden = false;
      return;
    }
    results.innerHTML = products.map(function (product, index) {
      var src = thumbSrc(product.image);
      var image = src
        ? '<img src="' + escapeHtml(src) + '" alt="" loading="lazy" decoding="async">'
        : '<span class="peptik-cat-search__thumb-fallback"></span>';
      var cents = priceCents(product.price);
      var priceAttribute = cents ? ' data-peptik-price-aed="' + cents + '"' : '';
      var soldOut = product.available === false;
      return '<a class="peptik-cat-search__hit' + (soldOut ? ' peptik-cat-search__hit--soldout' : '')
        + '" href="' + escapeHtml(product.url) + '" role="option" data-peptik-key="' + index + '">'
        + '<span class="peptik-cat-search__thumb">' + image + '</span>'
        + '<span class="peptik-cat-search__meta">'
        + '<span class="peptik-cat-search__title">' + escapeHtml(product.title) + '</span>'
        + '<span class="peptik-cat-search__price"' + priceAttribute + '>' + formatPrice(product.price) + '</span>'
        + (soldOut ? '<span class="peptik-cat-search__soldout">Sold out</span>' : '')
        + '</span></a>';
    }).join('');
    results.hidden = false;
  }

  function bindUnifiedSearch(form, input, results) {
    if (!form || !input || !results || input.__peptikUnifiedSearch) return;
    input.__peptikUnifiedSearch = true;
    var controller = null;
    var debounce = null;
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounce);
      if (controller) controller.abort();
      if (!query) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }
      debounce = setTimeout(function () {
        controller = new AbortController();
        var requestedQuery = query;
        unifiedFind(requestedQuery, controller.signal).then(function (products) {
          if (input.value.trim() !== requestedQuery) return;
          renderUnifiedResults(results, products);
        }).catch(function (error) {
          if (error.name !== 'AbortError') console.warn('search err', error);
        });
      }, 180);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim() && results.innerHTML) results.hidden = false;
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        results.hidden = true;
        input.blur();
      }
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var query = input.value.trim();
      if (query) window.location.assign('/search?type=product&q=' + encodeURIComponent(query));
    });
    document.addEventListener('click', function (event) {
      if (!form.contains(event.target) && !results.contains(event.target)) results.hidden = true;
    });
  }

  function replaceCollectionSearch() {
    var form = document.querySelector('[data-peptik-cat-search-form]');
    var oldInput = form && form.querySelector('[data-peptik-cat-search-input]');
    var results = document.querySelector('[data-peptik-cat-search-results]');
    if (!form || !oldInput || !results || oldInput.__peptikUnifiedSearch) return;
    var input = oldInput.cloneNode(true);
    oldInput.replaceWith(input);
    results.hidden = true;
    results.innerHTML = '';
    bindUnifiedSearch(form, input, results);
  }

  function replaceHeaderSearch() {
    var component = document.querySelector('predictive-search-component');
    if (!component) return;
    var nativeClose = component.querySelector('[ref="closeModalButton"]');
    var shell = document.createElement('div');
    shell.className = component.className + ' peptik-header-search-shell';
    shell.style.cssText = component.style.cssText;
    shell.dataset.peptikHeaderSearchShell = 'true';
    shell.setAttribute('role', 'search');
    shell.setAttribute('aria-label', component.getAttribute('aria-label') || 'Search');
    var form = document.createElement('form');
    form.className = 'peptik-cat-search-wrap peptik-header-unified-search';
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');
    form.innerHTML = ''
      + '<input type="hidden" name="type" value="product">'
      + '<div class="peptik-cat-search">'
      + '<span class="peptik-cat-search__icon" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="#686677" stroke-width="1.6"></circle><path d="m21 21-4.3-4.3" stroke="#686677" stroke-width="1.6" stroke-linecap="round"></path></svg></span>'
      + '<input type="search" name="q" class="peptik-cat-search__input" placeholder="Find your peptides" aria-label="Search peptides" autocomplete="off" ref="searchInput" data-peptik-header-search-input>'
      + '<button type="submit" class="peptik-cat-search__btn">Search</button>'
      + '<button type="button" ref="resetButton" hidden aria-hidden="true" tabindex="-1"></button>'
      + '</div>'
      + '<div class="peptik-cat-search__results" ref="predictiveSearchResults" data-peptik-header-search-results role="listbox" aria-label="Search results" hidden></div>';
    shell.appendChild(form);
    if (nativeClose) {
      nativeClose.style.setProperty('position', 'absolute', 'important');
      nativeClose.style.setProperty('top', '16px', 'important');
      nativeClose.style.setProperty('right', '16px', 'important');
      shell.appendChild(nativeClose);
    }
    component.replaceWith(shell);
    bindUnifiedSearch(
      form,
      form.querySelector('[data-peptik-header-search-input]'),
      form.querySelector('[data-peptik-header-search-results]')
    );
  }

  (function injectUnifiedStyle() {
    if (document.getElementById('peptik-unified-search-style')) return;
    var style = document.createElement('style');
    style.id = 'peptik-unified-search-style';
    style.textContent = ''
      + '.peptik-header-unified-search{width:min(100% - 32px,1100px);margin:28px auto 0;position:relative;z-index:2;}'
      + '.peptik-header-unified-search+.predictive-search__close-modal-button{position:absolute!important;top:16px!important;right:16px!important;}'
      + '.peptik-header-search-shell{display:block;position:relative;flex:1 1 auto;width:100%;min-height:100%;padding-top:36px;background:transparent;}'
      + '.peptik-header-unified-search .peptik-cat-search__results{position:relative;top:auto;left:auto;right:auto;margin-top:0;border-top:0;border-radius:0 0 16px 16px;box-shadow:none;}'
      + '@media(max-width:749px){.peptik-header-unified-search{width:calc(100% - 24px);margin-top:64px;}}';
    document.head.appendChild(style);
  })();

  replaceCollectionSearch();
  replaceHeaderSearch();
  new MutationObserver(function (records) {
    var predictiveSearchAdded = records.some(function (record) {
      return Array.prototype.some.call(record.addedNodes, function (node) {
        return node instanceof Element
          && (node.matches('predictive-search-component') || node.querySelector('predictive-search-component'));
      });
    });
    if (predictiveSearchAdded) replaceHeaderSearch();
  }).observe(document.documentElement, { childList: true, subtree: true });
  return;

  // Hide Shopify's single native bundle card once we render its explicit
  // Pen + Vial hits, so the bundle isn't shown twice (and ambiguously).
  // Idempotent: a card is only touched the first time it matches.
  function hideNativeBundleCards(host, handles) {
    if (!host || !handles || !handles.size) return;
    var cards = host.querySelectorAll('.predictive-search-results__card--product');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.getAttribute('data-peptik-bundle-hidden') === '1') return;
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m || !handles.has(m[1])) return;
      card.setAttribute('data-peptik-bundle-hidden', '1');
      card.style.display = 'none';
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function thumbSrc(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function renderHits(products, query) {
    if (!products.length) return '';
    var items = products.map(function (p) {
      var src = thumbSrc(p.image);
      var img = src
        ? '<img src="' + escapeHtml(src) + '" alt="" loading="lazy" decoding="async">'
        : '<span class="peptik-fuzzy__thumb-fallback"></span>';
      return ''
        + '<a class="peptik-fuzzy__hit" href="' + escapeHtml(p.url) + '">'
        + '<span class="peptik-fuzzy__thumb">' + img + '</span>'
        + '<span class="peptik-fuzzy__title">' + escapeHtml(p.title) + '</span>'
        + '</a>';
    }).join('');
    return ''
      + '<div class="peptik-fuzzy" data-peptik-fuzzy>'
      +   '<div class="peptik-fuzzy__label">Did you mean…</div>'
      +   '<div class="peptik-fuzzy__list">' + items + '</div>'
      + '</div>';
  }

  // Cross out Shopify's OWN native predictive product cards whose displayed
  // (first/namesake) variant is sold out. Idempotent: only mutates a card the
  // first time, so it can't drive the dropdown MutationObserver into a loop.
  function markNativeCards(host) {
    if (!host) return;
    loadCatalog().then(function (catalog) {
      if (!catalog || !catalog.length) return;
      var availByHandle = Object.create(null);
      var priceByHandle = Object.create(null);
      var tagsByHandle = Object.create(null);
      var catalogueParHandle = Object.create(null);
      catalog.forEach(function (p) { availByHandle[p.handle] = p.available; priceByHandle[p.handle] = parseFloat(p.price); tagsByHandle[p.handle] = p.tags; catalogueParHandle[p.handle] = p; });
      var cards = host.querySelectorAll('.predictive-search-results__card--product');
      // Reorder native predictive product cards: in-stock first, then lowest price.
      // Idempotent (only moves when order actually differs) so it can't drive the
      // dropdown MutationObserver into a loop. Recently-viewed keeps its recency order.
      (function reorderNative(){
        var groups = [];
        Array.prototype.forEach.call(cards, function (card) {
          if (card.closest('.recently-viewed-wrapper')) return;
          var ul = card.parentNode; if (!ul) return;
          var g = null; for (var gi=0; gi<groups.length; gi++){ if (groups[gi].ul === ul){ g = groups[gi]; break; } }
          if (!g) { g = { ul: ul, cards: [] }; groups.push(g); }
          g.cards.push(card);
        });
        groups.forEach(function (g) {
          if (g.cards.length < 2) return;
          var meta = g.cards.map(function (card, i) {
            var a = card.querySelector('a[href*="/products/"]');
            var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
            var hn = m ? m[1] : null;
            var av = (hn && availByHandle[hn] === false) ? 0 : 1;
            var pr = (hn && isFinite(priceByHandle[hn])) ? priceByHandle[hn] : Infinity;
            var rk = peptikPrio(hn ? tagsByHandle[hn] : '');
            return { card: card, i: i, av: av, pr: pr, rk: rk };
          });
          // Les cartes natives de Shopify pointent la fiche sans variante : meme piege.
          meta.forEach(function (m) {
            var a = m.card.querySelector('a[href*="/products/"]');
            if (!a) return;
            var href = a.getAttribute('href') || '';
            var hm = href.match(/\/products\/([^/?#]+)/);
            var e = hm ? catalogueParHandle[hm[1]] : null;
            var id = e ? peptikVarianteCible(e) : null;
            if (id) a.setAttribute('href', peptikUrlVariante(href, id));
          });
          var sorted = meta.slice().sort(function (a, b) {
            if (a.av !== b.av) return b.av - a.av;
            if (a.rk !== b.rk) return a.rk - b.rk;
            if (a.pr !== b.pr) return a.pr - b.pr;
            return a.i - b.i;
          });
          if (!sorted.some(function (s, i) { return s.card !== g.cards[i]; })) return;
          sorted.forEach(function (s) { g.ul.appendChild(s.card); });
        });
      })();
      Array.prototype.forEach.call(cards, function (card) {
        if (card.classList.contains('predictive-search-results__card--soldout')) return;
        var a = card.querySelector('a[href*="/products/"]');
        if (!a) return;
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (!m || availByHandle[m[1]] !== false) return;
        card.classList.add('predictive-search-results__card--soldout');
        var titleEl = card.querySelector('.resource-card__title-link, .resource-card__title, .predictive-search-results__card-title');
        if (titleEl && titleEl.parentNode && !card.querySelector('.peptik-native-soldout')) {
          var tag = document.createElement('span');
          tag.className = 'peptik-native-soldout';
          tag.textContent = 'Sold out';
          titleEl.parentNode.insertBefore(tag, titleEl.nextSibling);
        }
      });
    });
  }

  // ----- Injection into Shopify's predictive-search dropdown -----
  function getDropdownHost(input) {
    var component = input.closest('predictive-search-component') || document.querySelector('predictive-search-component');
    if (!component) return null;
    return component.querySelector('.predictive-search-form__content, .predictive-search-dropdown, [ref="predictiveSearchResults"]');
  }
  function shopifyHasGoodResults(host) {
    if (!host) return false;
    // If Shopify rendered at least one product card, treat it as a hit and
    // skip the fuzzy injection so we don't pollute solid matches.
    return !!host.querySelector('.predictive-search-results__card--product a, .predictive-search-results__products a');
  }
  // Stable per-host state so the fuzzy panel is INSERTED ONCE and updated
  // in place. The previous version removed + re-inserted the whole block on
  // every observer trigger, which caused two compounding bugs:
  //   1. The observer watches the whole component (childList:true,subtree:true)
  //      and our own insertion fires it again → infinite re-inject loop every
  //      50ms → between mousedown and click the <a class="peptik-fuzzy__hit">
  //      is replaced and the click is lost (UNCLICKABLE bug).
  //   2. The same loop kept restarting the CSS hover transition under the
  //      cursor (light-blue blink).
  // Fix: keep a persistent container element, only update its innerHTML when
  // the rendered list actually changed, suspend the observer while we mutate.
  var hostState = new WeakMap(); // host element -> { container, lastSig, observer, suspended }

  function getHostState(h) {
    var s = hostState.get(h);
    if (!s) { s = { container: null, lastSig: '', observer: null, suspended: false }; hostState.set(h, s); }
    return s;
  }

  function renderListHtml(products) {
    // Just the inner `.peptik-fuzzy__list` items — the wrapper is built once.
    return products.map(function (p) {
      var src = thumbSrc(p.image);
      var img = src
        ? '<img src="' + escapeHtml(src) + '" alt="" loading="lazy" decoding="async">'
        : '<span class="peptik-fuzzy__thumb-fallback"></span>';
      var soldOut = p.available === false;
      return ''
        + '<a class="peptik-fuzzy__hit' + (soldOut ? ' peptik-fuzzy__hit--soldout' : '') + '" href="' + escapeHtml(p.url) + '">'
        + '<span class="peptik-fuzzy__thumb">' + img + '</span>'
        + '<span class="peptik-fuzzy__title">' + escapeHtml(p.title) + '</span>'
        + (soldOut ? '<span class="peptik-fuzzy__soldout">Sold out</span>' : '')
        + '</a>';
    }).join('');
  }

  function buildContainer() {
    var el = document.createElement('div');
    el.className = 'peptik-fuzzy';
    el.setAttribute('data-peptik-fuzzy', '');
    el.innerHTML =
      '<div class="peptik-fuzzy__label">Did you mean…</div>' +
      '<div class="peptik-fuzzy__list" data-peptik-fuzzy-list></div>';
    return el;
  }

  function patch(input) {
    var q = (input.value || '').trim();
    var host = getDropdownHost(input);
    if (!host) return;
    markNativeCards(host);
    var st = getHostState(host);
    if (q.length < 2) {
      if (st.container && st.container.isConnected) {
        st.suspended = true;
        st.container.remove();
        st.lastSig = '';
        // Re-arm observer on next tick.
        setTimeout(function () { st.suspended = false; }, 0);
      }
      return;
    }
    fuzzyFind(q, 6).then(function (rawProducts) {
      var h = getDropdownHost(input);
      if (!h) return;
      if ((input.value || '').trim() !== q) return;
      var stNow = getHostState(h);
      // Expand matched bundles into Pen + Vial hits before de-duping.
      var products = expandBundles(rawProducts);
      if (shopifyHasGoodResults(h) && products.length > 0) {
        var dom = h.querySelectorAll('.predictive-search-results__card--product a, .predictive-search-results__products a');
        var existingHandles = new Set();
        dom.forEach(function (a) {
          var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
          if (m) existingHandles.add(m[1]);
        });
        // Split hits are kept even when Shopify already shows the bundle (we
        // replace its one ambiguous card with our two variant options); plain
        // hits Shopify already shows are dropped to avoid duplicates.
        var bundlesToHide = new Set();
        products = products.filter(function (p) {
          if (p._split) {
            if (existingHandles.has(p.handle)) bundlesToHide.add(p.handle);
            return true;
          }
          return !existingHandles.has(p.handle);
        });
        if (bundlesToHide.size) hideNativeBundleCards(h, bundlesToHide);
      }
      // In-stock first. Shopify's own predictive cards already reorder this way (see
      // reorderNative below); these hits did not, so a crossed-out result could sit above
      // something the shopper can actually buy. Sort is stable, so match quality is kept
      // inside each group — and it runs BEFORE the slice, so a buyable hit ranked ninth
      // takes the place of a sold-out one rather than being cut.
      // Chaque hit non eclate part vers la variante de SON format (voir peptikVarianteCible).
      products.forEach(function (p) {
        if (p._split) return;
        var id = peptikVarianteCible(p);
        if (id) p.url = peptikUrlVariante(p.url, id);
      });
      products = products.map(function (p, i) { return { p: p, i: i }; }).sort(function (a, b) {
        if (a.p.available !== b.p.available) return a.p.available ? -1 : 1;
        var r = peptikPrio(a.p.tags) - peptikPrio(b.p.tags);
        if (r !== 0) return r;
        return a.i - b.i;
      }).map(function (x) { return x.p; });
      products = products.slice(0, 8);
      // Signature so identical results don't trigger a DOM mutation. Keyed on
      // url so the two variant hits of a bundle don't collapse together.
      var sig = products.map(function (p) { return p.url; }).join('|');
      if (!products.length) {
        if (stNow.container && stNow.container.isConnected) {
          stNow.suspended = true;
          stNow.container.remove();
          stNow.lastSig = '';
          setTimeout(function () { stNow.suspended = false; }, 0);
        }
        return;
      }
      if (sig === stNow.lastSig && stNow.container && stNow.container.isConnected && stNow.container.parentNode === h) {
        return; // Identical to what's already on screen — no mutation.
      }
      // Suspend observer while we mutate so we don't re-enter the loop.
      stNow.suspended = true;
      if (!stNow.container) stNow.container = buildContainer();
      var list = stNow.container.querySelector('[data-peptik-fuzzy-list]');
      if (list) list.innerHTML = renderListHtml(products);
      var labelEl = stNow.container.querySelector('.peptik-fuzzy__label');
      if (labelEl) labelEl.textContent = products.some(function (p) { return p._split; }) ? 'Pen & vial options' : 'Did you mean…';
      // Ensure the container is present and first child of the host. Use
      // direct DOM ops so we mutate the SAME element (no remove+reinsert,
      // which would interrupt any in-flight click on a child <a>).
      if (stNow.container.parentNode !== h) {
        if (stNow.container.parentNode) stNow.container.parentNode.removeChild(stNow.container);
        h.insertBefore(stNow.container, h.firstChild);
      } else if (h.firstChild !== stNow.container) {
        h.insertBefore(stNow.container, h.firstChild);
      }
      stNow.lastSig = sig;
      // Re-arm observer on next microtask.
      setTimeout(function () { stNow.suspended = false; }, 0);
    });
  }

  function isSearchInput(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.tagName !== 'INPUT') return false;
    if (el.type !== 'search' && el.getAttribute('type') !== 'search') return false;
    if (el.name !== 'q' && el.getAttribute('name') !== 'q') return false;
    if (!el.closest('predictive-search-component')) return false;
    return true;
  }

  var debounceTimer;
  document.addEventListener('input', function (e) {
    if (!isSearchInput(e.target)) return;
    clearTimeout(debounceTimer);
    var input = e.target;
    debounceTimer = setTimeout(function () { patch(input); }, 200);
  }, true);

  // Re-patch when Shopify re-renders the dropdown subtree (morphs on each
  // keystroke). The observer ignores its own self-triggered mutations via
  // the `suspended` flag on the per-host state.
  function observeDropdowns() {
    document.querySelectorAll('predictive-search-component').forEach(function (component) {
      if (component.__peptikObserved) return;
      component.__peptikObserved = true;
      var input = component.querySelector('input[type="search"][name="q"]');
      if (!input) return;
      var mo = new MutationObserver(function (mutations) {
        // Ignore mutations that originated INSIDE our own .peptik-fuzzy
        // container — those are us updating the list, not Shopify re-rendering.
        var ours = mutations.every(function (m) {
          var t = m.target;
          return t && (t.closest && t.closest('[data-peptik-fuzzy]'));
        });
        if (ours) return;
        // Shopify's response can land in the same observer batch as our own
        // insertion. In that case the native morph removes the fuzzy panel
        // while the host is still marked suspended. Reconcile once the current
        // mutation batch is over instead of dropping that native update.
        var currentInput = component.querySelector('input[type="search"][name="q"]');
        if (!currentInput || !currentInput.value || !currentInput.value.trim()) return;
        var host = getDropdownHost(currentInput);
        if (host && getHostState(host).suspended) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            var latestInput = component.querySelector('input[type="search"][name="q"]');
            if (latestInput && latestInput.value && latestInput.value.trim()) patch(latestInput);
          }, 0);
          return;
        }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          var latestInput = component.querySelector('input[type="search"][name="q"]');
          if (latestInput) patch(latestInput);
        }, 80);
      });
      mo.observe(component, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDropdowns, { once: true });
  } else {
    observeDropdowns();
  }
  // Re-scan in case the modal mounts later (lazy section render).
  setTimeout(observeDropdowns, 500);
  setTimeout(observeDropdowns, 2000);
})();
